import React from "react";
import { buildRoutes } from "@app/routes/RouteBuilder";
import lazyWithRetry from "@shared/utils/lazyWithRetry";

// Lazy loading con retry automático
const CalendarioSocial = lazyWithRetry(
  () => import("./ui/CalendarioSocial"),
  "CalendarioSocial",
);

/**
 * Rutas del calendario social
 */
const calendarRoutes = buildRoutes([
  {
    path: "/calendario-social",
    element: CalendarioSocial,
    roles: [1, 2, 5, 7],
  },
]);

export default calendarRoutes;
